import * as React from 'react';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import { FlexColumn, H3, SectionBody, SectionHeader } from '@portal/common/components';
import { styled } from '@portal/common/theme';
import { RefinementFilterConfig } from '@portal/common/types';

import _ from '../../locale';
import { getDataToolConfig } from '../../store/data-explorer/selectors';
import LimitWarnings from '../LimitWarnings';
import ConditionAndTypeSelector from './ConditionAndTypeSelector';
import DataCollectionSelector from './DataCollectionSelector';
import RefinementFiltersControls from './RefinementFiltersControls';

const StyledSectionBody = styled(SectionBody)<{
    isHidden: boolean;
}>(({ isHidden }) => ({
    marginTop: 0,
    position: 'static',
    ...(isHidden && {
        top: -1000,
        position: 'fixed',
        opacity: 0,
        pointerEvents: 'none',
    }),
}));

type Props = {
    refinementFiltersConfig?: RefinementFilterConfig;
    areChartsVisible: boolean;
    toggleChartsVisibility: () => void;
};

const SelectDataSection: FC<Props> = ({
    refinementFiltersConfig,
    toggleChartsVisibility,
    areChartsVisible,
}) => {
    const dataToolConfig = useSelector(getDataToolConfig);

    const isDataCollectionSelectorVisible = dataToolConfig?.dataCollectionSelectorVisibility;

    return (
        <StyledSectionBody isHidden={!!dataToolConfig.hideSelectDataSection}>
            <SectionHeader>
                <H3>{_('data_explorer_select_data')}</H3>
            </SectionHeader>
            <FlexColumn itemsSpacing={10} grow={1}>
                {isDataCollectionSelectorVisible && <DataCollectionSelector />}
                <ConditionAndTypeSelector showSmartOptions />
                <RefinementFiltersControls
                    refinementFiltersConfig={refinementFiltersConfig}
                    {...{ toggleChartsVisibility, areChartsVisible }}
                />
            </FlexColumn>
            <LimitWarnings />
        </StyledSectionBody>
    );
};

export default SelectDataSection;
